import React from "react";
import { VStack, Heading } from "@chakra-ui/react";
import LabeledText from "../../Common/Layout/LabeledText";
import ContentCard from "../../Common/Layout/ContentCard";
import { currencyFormatter } from "../../../Utils/formatUtils";

const NewOrderData = ({ total }) => {
  return (
    <ContentCard w={["auto", "50%"]}>
      <Heading variant="h2">Estado de la venta</Heading>
      <VStack align="left" fontSize="0.9em">
        <LabeledText label="Estado" text={"Creado"}></LabeledText>
        <LabeledText
          label="Subtotal"
          text={`${currencyFormatter(total)}`}
        ></LabeledText>
      </VStack>
    </ContentCard>
  );
};

export default NewOrderData;
